import { render, staticRenderFns } from "./VersionManager.vue?vue&type=template&id=3a2d7add&scoped=true&"
import script from "./VersionManager.vue?vue&type=script&lang=js&"
export * from "./VersionManager.vue?vue&type=script&lang=js&"
import style0 from "./VersionManager.vue?vue&type=style&index=0&id=3a2d7add&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2d7add",
  null
  
)

export default component.exports